module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('WebTemplate', {
    attrs: {
      "pagetitle": "来源分析",
      "tip": "本报告帮助您了解您网站流量来源的组成，从直接访问、搜索引擎和外部链接三个方面帮助您深入分析流量分布。助您有效管理网络推广渠道，合理优化推广方案",
      "currentTab": _vm.currentTab,
      "compareDisabled": _vm.compareDisabled,
      "hasCrowd": _vm.hasCrowd,
      "total": _vm.total,
      "pg": _vm.pg,
      "ps": _vm.ps,
      "tablist": _vm.tablist,
      "tableDataList": _vm.tableDataList,
      "hasCheckBox": _vm.hasCheckBox,
      "checkboxLength": _vm.checkboxLength,
      "sumchecked": _vm.sumChecked,
      "sum": _vm.sum,
      "order": _vm.order,
      "legend": _vm.legend,
      "yAxis": _vm.yAxis,
      "chartXAxis": _vm.chartXAxis,
      "chartSeries": _vm.chartSeries,
      "customIndice": _vm.customIndice,
      "twoIndiceShow": _vm.twoIndiceShow,
      "twoIndice": _vm.twoIndice
    },
    on: {
      "indiceChange": _vm.indiceChange,
      "timeRangeChange": _vm.getDataWithCrowd,
      "tableUpdate": _vm.updatePage,
      "tablesorter": _vm.tablesorter
    }
  }, [_c('template', {
    slot: "tabview"
  }, [_c('ul', {
    staticClass: "tab"
  }, _vm._l((_vm.tabViews), function(item) {
    return _c('li', {
      staticClass: "tab-item"
    }, [_c('div', {
      staticClass: "tabview-btn",
      class: {
        active: _vm.currentView === item.comp
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeViewTo(item.comp)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])
  }))]), _c('template', {
    slot: "crowd"
  }, [_c('CrowTags', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentView != 'externalLink'),
      expression: "currentView != 'externalLink'"
    }],
    attrs: {
      "selectedCrowd": _vm.selectedCrowd
    },
    on: {
      "showCrowd": _vm.showCrowd,
      "dropCrowd": _vm.dropCrowd,
      "openCrowd": _vm.openCrowd
    }
  })], 1), _c('template', {
    slot: "crowd-content"
  }, [(_vm.crowdShow) ? _c('CrowEditTemplate', {
    attrs: {
      "crowShowType": _vm.currentCrowdType,
      "crowdList": _vm.crowdList
    },
    on: {
      "updateCrowdList": _vm.getCrowdList,
      "updatePage": _vm.getTableData,
      "apply": _vm.applyCrowd,
      "reset": _vm.resetCrowd,
      "removeUpdate": _vm.removeUpdate
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "nav-tabs",
    slot: "nav-tabs"
  }, [_c('TabContent', {
    attrs: {
      "title": "主维度：",
      "tablist": _vm.tablist,
      "update": _vm.updateTab,
      "currentTab": _vm.currentTab
    }
  }, [_c('div', {
    staticClass: "right-tab",
    slot: "extentTab"
  }, [(_vm.total > 0) ? _c('DownloadBtn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "reportApi": _vm.reportApi,
      "params": _vm.query,
      "pagetitle": _vm.tableTabTitle,
      "subtitle": ""
    }
  }) : _vm._e(), _c('CustomIndice', {
    attrs: {
      "defaults": _vm.defaultCustomIndices,
      "hasSystemIndice": _vm.hasSystemIndice
    },
    on: {
      "change": _vm.onCustomIndiceChange
    }
  })], 1), _c('div', {
    slot: "common"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sdimOptionShow),
      expression: "sdimOptionShow"
    }],
    staticClass: "plan-nav"
  }, [_vm._v("选择二级维度："), _c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sdim),
      expression: "sdim"
    }],
    attrs: {
      "name": "secondaryDim",
      "options": _vm.sdimOptions
    },
    domProps: {
      "value": (_vm.sdim)
    },
    on: {
      "input": function($event) {
        _vm.sdim = $event
      }
    },
    nativeOn: {
      "change": function($event) {
        _vm.sdimChange($event)
      }
    }
  })], 1), _c('p', {
    staticClass: "tabAction"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-big",
    attrs: {
      "disabled": _vm.fetchLineChartabled
    },
    on: {
      "click": _vm.fetchLineChartData
    }
  }, [_vm._v("绘制选定行")]), _c('Search', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentView == 'externalLink'),
      expression: "currentView == 'externalLink'"
    }],
    attrs: {
      "placeholder": _vm.placeHolder,
      "defaultValue": _vm.keyword
    },
    on: {
      "doSearch": _vm.doSearch
    }
  })], 1)])])], 1), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transTypeShow),
      expression: "transTypeShow"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.transelected),
      expression: "transelected"
    }],
    attrs: {
      "options": _vm.transList
    },
    domProps: {
      "value": (_vm.transelected)
    },
    on: {
      "input": [function($event) {
        _vm.transelected = $event
      }, function($event) {
        _vm.transChangeWithCrowd()
      }]
    },
    slot: "custom"
  })], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.calcLoading),
      expression: "calcLoading"
    }],
    staticClass: "report-content"
  }, [_vm._m(0)]), _c('v-modal', {
    ref: "mvModal",
    attrs: {
      "visible": _vm.isMv
    }
  }, [_c('div', {
    staticClass: "modal-hd"
  }, [_c('a', {
    staticClass: "fa fa-times close",
    on: {
      "click": function($event) {
        _vm.isMv = false
      }
    }
  })]), _c('div', {
    staticClass: "modal-bd"
  }, [_c('p', {
    staticClass: "text-content"
  }, [_vm._v("使用该功能需要在网站部署360分析代码")]), _c('p', {
    staticClass: "mv-container"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-small btn-mgr",
    on: {
      "click": function($event) {
        _vm.gotoSetting()
      }
    }
  }, [_vm._v("去设置")])])])]), _c('div', {
    staticClass: "guid"
  }, [(_vm.guidShow) ? _c('div', {
    staticClass: "guid-mask"
  }, [(!_vm.createGuidShow && !_vm.systemGuidShow) ? _c('div', {
    staticClass: "guid-add"
  }, [_c('img', {
    attrs: {
      "src": "https://p3.ssl.qhimg.com/t01b752e208c7f4c190.png"
    }
  }), _c('a', {
    staticClass: "guid-close",
    on: {
      "click": _vm.openSystemGuid
    }
  }, [_vm._v("知 道 啦")])]) : _vm._e(), (_vm.createGuidShow) ? _c('div', {
    staticClass: "guid-create"
  }, [_c('img', {
    attrs: {
      "src": "https://p5.ssl.qhimg.com/t01114bcfb959b5a1c1.png"
    }
  }), _c('a', {
    staticClass: "guid-close",
    on: {
      "click": _vm.removeGuid
    }
  }, [_vm._v("关 闭")])]) : _vm._e(), (_vm.systemGuidShow) ? _c('div', {
    staticClass: "guid-system"
  }, [_c('a', {
    staticClass: "guid-close",
    on: {
      "click": _vm.openCreateGuid
    }
  }, [_vm._v("知 道 啦")])]) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask-panel"
  }, [_c('img', {
    attrs: {
      "src": "https://p1.ssl.qhimg.com/t0173f568f185dc492d.gif"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-495ad900", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-495ad900!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/origin.vue
// module id = 750
// module chunks = 0